import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';

import { SharedModule } from '../shared/shared.module';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { Auth0CallbackComponent } from './auth0-callback/auth0-callback.component';
import { LoginComponent } from './login/login.component';
import { EmailRequiredComponent } from './email-required/email-required.component';
import { AccountNotActivatedComponent } from './account-not-activated/account-not-activated.component';
import { AuthenticationErrorComponent } from './authentication-error/authentication-error.component';
import { SsoAuthService } from '../ecan/sso-auth.service';
import { AppConfigurationService } from '../stp/stp-app/common';
import { UrlService } from '../shared/services/url.service';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { jwtOptionsFactory } from './jwtOptionsFactory';
import { AuditorRoleRequiredComponent } from './auditor-role-required/auditor-role-required.component';
import { LayoutComponent } from './layout/layout.component';


@NgModule({
  declarations: [
    AutoLoginComponent,
    Auth0CallbackComponent,
    LoginComponent,
    EmailRequiredComponent,
    AccountNotActivatedComponent,
    AuthenticationErrorComponent,
    AuditorRoleRequiredComponent,
    LayoutComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    AuthenticationRoutingModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [SsoAuthService, AppConfigurationService, UrlService]
      }
    })
  ]
})
export class AuthenticationModule { }
